<div #containerRoot class="container" [class.tutorial-focus-role-guide]="tutorialService.isStepActive('lab-members-help')">
  <div *ngIf="tutorialService.isStepActive('lab-members-help')" class="local-tutorial-overlay">
    <div *ngFor="let panelStyle of localTutorialShadeStyles" class="local-tutorial-shade-panel" [ngStyle]="panelStyle"></div>
  </div>
  <div class="members-header-shell">
    <div class="members-header-actions">
      <button #roleGuideButton type="button" class="members-role-guide-button" [class.members-role-guide-button-highlighted]="tutorialService.isStepActive('lab-members-help')" data-tutorial-target="lab-members-role-help" (click)="openRoleHelp()"
        (touchend)="$event.preventDefault(); $event.stopPropagation(); openRoleHelp();">
        <span class="members-role-guide-badge">?</span>
        <span>{{ 'Role guide' | translate }}</span>
      </button>
      <button *ngIf="!tutorialService.isLabMembersTutorialActive" type="button" class="members-tutorial-button" (click)="startLabMembersTutorial()">{{ 'Start Tutorial' | translate }}</button>
    </div>

    <p class="subheader-text members-header-text">{{ 'Members' | translate }}</p>
  </div>

  <div class="lab-users-container">
    <!--Lab Users-->
    <ng-container *ngFor="let labUserComplete of clonedLabUsersComplete; let i = index">
      <div *ngIf="labUserComplete.labUser.active == true" class="row">
        <!--User Name-->
        <mat-form-field class="contact-info-input" appearance="fill">
          <input [disabled]="true" [(ngModel)]="labUserComplete.userSafe.nickname" maxlength="320"
            (touchend)="$event.stopPropagation()" matInput [placeholder]="'Lab User' | translate">
        </mat-form-field>

        <!--Role-->
        <mat-form-field appearance="fill">
          <mat-select [disabled]="!canUserEditLabUser(labUserComplete)" (touchend)="$event.stopPropagation()"
            [(ngModel)]="labUserComplete.labUser.newRoleId">
            <mat-option *ngIf="labUserComplete.labUser.roleId == RoleEnum.OWNER"
              [value]="RoleEnum.OWNER">{{ 'Owner' | translate }}</mat-option>
            <mat-option [disabled]="labComplete.currentLabUserComplete.labUser.roleId > RoleEnum.ADMIN"
              [value]="RoleEnum.ADMIN">{{ 'Admin' | translate }}</mat-option>
            <mat-option [value]="RoleEnum.CREATOR">{{ 'Creator' | translate }}</mat-option>
            <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>

          </mat-select>
        </mat-form-field>

        <button [ngClass]="canUserEditLabUser(labUserComplete) ? '' : 'hidden-filler-btn'"
          (click)="toggleDeleteLabUser(labUserComplete,i)"
          (touchend)="$event.preventDefault();$event.stopPropagation();toggleDeleteLabUser(labUserComplete,i);"
          class="component-content login-button welcome-input mat-primary-lighter" mat-raised-button
          color="warn">-</button>

      </div>

    </ng-container>

    <!--Deleting Lab Users-->
    <ng-container *ngIf="isThereAUserBeingDeleted">
      <div class="row">
        <p class="subheader-text subheader">{{ 'Members being deleted:' | translate }}</p>
      </div>
      <ng-container *ngFor="let labUserComplete of clonedLabUsersComplete; let i = index">
        <div *ngIf="labUserComplete.labUser.active == false" class="row">
          <!--User Name-->
          <mat-form-field class="contact-info-input" appearance="fill">
            <input [disabled]="true" [(ngModel)]="labUserComplete.userSafe.nickname" maxlength="320"
              (touchend)="$event.stopPropagation()" matInput [placeholder]="'Lab User' | translate">
          </mat-form-field>

          <!--Role-->
          <mat-form-field appearance="fill">
            <mat-select [disabled]="true" (touchend)="$event.stopPropagation()"
              [(ngModel)]="labUserComplete.labUser.newRoleId">
              <mat-option *ngIf="labUserComplete.labUser.roleId == RoleEnum.OWNER"
                [value]="RoleEnum.OWNER">{{ 'Owner' | translate }}</mat-option>
              <mat-option [disabled]="labUserComplete.labUser.roleId > RoleEnum.ADMIN"
                [value]="RoleEnum.ADMIN">{{ 'Admin' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>

            </mat-select>
          </mat-form-field>

          <button [ngClass]="canUserEditLabUser(labUserComplete) ? '' : 'hidden-filler-btn'"
            (click)="toggleDeleteLabUser(labUserComplete,i)"
            (touchend)="$event.preventDefault();$event.stopPropagation();toggleDeleteLabUser(labUserComplete,i);"
            class="component-content login-button welcome-input mat-primary-lighter" mat-raised-button
            color="primary">+</button>

        </div>
      </ng-container>
    </ng-container>

    <!--Lab User Requests-->
    <ng-container *ngIf="isThereAnActiveUserRequest">
      <div class="row">
        <p class="subheader-text subheader">{{ 'Lab User Requests:' | translate }}</p>
      </div>
      <ng-container *ngFor="let labUserRequestComplete of clonedLabUserRequestsComplete; let i = index">

        <div *ngIf="labUserRequestComplete.labUserRequest.deleting == false" class="row">
          <!--User Name-->
          <mat-form-field class="contact-info-input" appearance="fill">
            <input [disabled]="true" [(ngModel)]="labUserRequestComplete.userSafe.nickname" maxlength="320"
              (touchend)="$event.stopPropagation()" matInput [placeholder]="'Name' | translate">
          </mat-form-field>

          <!--Role-->
          <mat-form-field appearance="fill">
            <mat-select
              [disabled]="!labComplete?.currentLabUserComplete?.labUser?.roleId || labComplete.currentLabUserComplete.labUser.roleId > RoleEnum.ADMIN"
              (touchend)="$event.stopPropagation()" [(ngModel)]="labUserRequestComplete.labUserRequest.roleId">
              <mat-option
                [disabled]="!labComplete?.currentLabUserComplete?.labUser?.roleId || labComplete.currentLabUserComplete.labUser.roleId > RoleEnum.ADMIN"
                [value]="RoleEnum.ADMIN">{{ 'Admin' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.CREATOR">{{ 'Creator' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>

            </mat-select>
          </mat-form-field>

          <button
            [ngClass]="!labComplete?.currentLabUserComplete?.labUser?.roleId || labComplete.currentLabUserComplete.labUser.roleId <= RoleEnum.ADMIN ? '' : 'hidden-filler-btn'"
            (click)="toggleDeleteLabUserRequest(labUserRequestComplete,i)"
            (touchend)="$event.preventDefault();$event.stopPropagation();toggleDeleteLabUserRequest(labUserRequestComplete,i);"
            class="component-content login-button welcome-input " mat-raised-button color="warn">-</button>

        </div>

      </ng-container>
    </ng-container>


    <!--Create Lab User Request-->
    <ng-container *ngIf="labComplete?.currentLabUserComplete?.labUser?.roleId <= RoleEnum.ADMIN">
      <div class="row">
        <p class="subheader-text subheader">{{ 'Create Lab User Requests:' | translate }}</p>
      </div>
      <div class="add-contact-container">
        <div class="row">
          <!--Add friend to lab-->
          <mat-form-field appearance="fill">
            <mat-select (touchend)="$event.stopPropagation()" [(ngModel)]="newLabUserContact">
              <mat-option *ngFor="let userContact of availableContactsToAddToLab"
                [value]="userContact">{{userContact.nickname}}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="fill">
            <mat-select (touchend)="$event.stopPropagation()" [(ngModel)]="newLabUserRole">
              <mat-option
                [disabled]="!labComplete?.currentLabUserComplete?.labUser?.roleId || labComplete.currentLabUserComplete.labUser.roleId > RoleEnum.ADMIN"
                [value]="RoleEnum.ADMIN">{{ 'Admin' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.CREATOR">{{ 'Creator' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>
            </mat-select>
          </mat-form-field>

          <button (click)="createLabUserRequest()"
            (touchend)="$event.preventDefault();$event.stopPropagation();createLabUserRequest();"
            class="component-content login-button welcome-input mat-primary-lighter" mat-raised-button
            color="primary">+</button>

        </div>


      </div>

    </ng-container>

    <!--Deleting Lab User Requests-->
    <ng-container
      *ngIf="isThereAUserRequestBeingDeleted && labComplete?.currentLabUserComplete?.labUser?.roleId <= RoleEnum.ADMIN">
      <div class="row">
        <p class="subheader-text subheader">{{ 'Lab user requests being deleted:' | translate }}</p>
      </div>
      <ng-container *ngFor="let labUserRequestComplete of clonedLabUserRequestsComplete; let i = index">
        <div *ngIf="labUserRequestComplete.labUserRequest.deleting == true" class="row">
          <!--User Name-->
          <mat-form-field class="contact-info-input" appearance="fill">
            <input [disabled]="true" [(ngModel)]="labUserRequestComplete.userSafe.nickname" maxlength="320"
              (touchend)="$event.stopPropagation()" matInput placeholder="">
          </mat-form-field>

          <!--Role-->
          <mat-form-field appearance="fill">
            <mat-select [disabled]="true" (touchend)="$event.stopPropagation()"
              [(ngModel)]="labUserRequestComplete.labUserRequest.roleId">
              <mat-option [value]="RoleEnum.ADMIN">{{ 'Admin' | translate }}</mat-option>
              <mat-option [value]="RoleEnum.USER">{{ 'Viewer' | translate }}</mat-option>

            </mat-select>
          </mat-form-field>

          <button
            [ngClass]="!labComplete?.currentLabUserComplete?.labUser?.roleId || labComplete.currentLabUserComplete.labUser.roleId <= RoleEnum.ADMIN ? '' : 'hidden-filler-btn'"
            (click)="toggleDeleteLabUserRequest(labUserRequestComplete,i)"
            (touchend)="$event.preventDefault();$event.stopPropagation();toggleDeleteLabUserRequest(labUserRequestComplete,i);"
            class="component-content login-button welcome-input mat-primary-lighter" mat-raised-button
            color="primary">+</button>

        </div>
      </ng-container>
    </ng-container>

    <!--Update-->
    <button *ngIf="labComplete?.currentLabUserComplete?.labUser?.roleId <= RoleEnum.ADMIN"
      [disabled]="tutorialService.isLabMembersTutorialActive"
      (click)="updateLabUserSettings()"
      (touchend)="$event.preventDefault();$event.stopPropagation();updateLabUserSettings();"
      class="component-content login-button welcome-input mat-primary-lighter" mat-raised-button color="primary">{{ 'Update Lab Users' | translate }}</button>

  </div>
</div>